type KinfeedMediaProps = {
  photos: string[];
  videos?: string[];
  onOpenPhoto: (index: number) => void;
  className?: string;
};

const cx = (...values: Array<string | false | null | undefined>) => values.filter(Boolean).join(" ");

const KinfeedMedia = ({ photos, videos = [], onOpenPhoto, className }: KinfeedMediaProps) => {
  const visiblePhotos = photos.slice(0, 4);
  const photoCount = visiblePhotos.length;

  return (
    <div className={cx("space-y-2", className)}>
      {photoCount ? (
        <div
          className={cx(
            "grid w-full gap-1 overflow-hidden rounded-[18px] bg-muted/60",
            photoCount === 1 && "grid-cols-1",
            photoCount >= 2 && "grid-cols-2",
            photoCount >= 3 && "grid-rows-2",
          )}
          style={{ aspectRatio: photoCount === 1 ? "4 / 3" : photoCount === 2 ? "16 / 9" : "4 / 3" }}
        >
          {visiblePhotos.map((url, index) => {
            const isLeadOfThree = photoCount === 3 && index === 0;
            const extraCount = index === 3 ? Math.max(0, photos.length - 4) : 0;

            return (
              <button
                key={`${url}-${index}`}
                type="button"
                aria-label={`Open photo ${index + 1} of ${photos.length}`}
                onClick={() => onOpenPhoto(index)}
                className={cx(
                  "relative min-h-0 min-w-0 overflow-hidden bg-muted",
                  photoCount === 1 && "h-full",
                  photoCount === 2 && "h-full",
                  isLeadOfThree && "row-span-2",
                )}
              >
                <img src={url} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-200 hover:scale-[1.01]" />
                {extraCount > 0 ? (
                  <span className="absolute inset-0 flex items-center justify-center bg-black/55 text-xl font-semibold text-white">
                    +{extraCount}
                  </span>
                ) : null}
              </button>
            );
          })}
        </div>
      ) : null}

      {videos.slice(0, 1).map((url) => (
        <video
          key={url}
          src={url}
          controls
          playsInline
          preload="metadata"
          className="aspect-video w-full rounded-[18px] bg-black object-contain"
        >
          Your browser does not support video playback.
        </video>
      ))}
    </div>
  );
};

export default KinfeedMedia;
